import {useEffect, useMemo} from "react";
import {Alert, Box, Grid, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {setToken} from "@/utils/functions.ts";
import {useNavigate} from "react-router-dom";

export default function Impersonation() {
    const navigate = useNavigate();
    const params = useMemo(() => new URLSearchParams(location.search), []);

    const now = Date.now();
    const access_token = useMemo(() => params.get('jwt'), [params]);
    const exp = useMemo(() => Number(params.get('exp')) * 1000, [params]);
    const uuid = useMemo(() => params.get('uuid') || '', [params]);

    useEffect(() => {
        if (access_token && (exp > now) && uuid !== '') {
            setToken(access_token, exp, uuid);
            navigate("/");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [now, exp]);

    return (
        <Box sx={{bgcolor: "#F8F8F8", height: "100vh"}}>
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{height: "inherit"}}>
                <Grid item md={3} xs={12} sx={{p: 2}}>
                    <Box sx={{mb: 2, display: "flex", justifyContent: "center"}}>
                        <img src="/assets/icon.png" width={50} height={50} alt="logo"/>
                    </Box>
                    {(exp < now) && (
                        <Box sx={{mb: 2, p: 5, borderRadius: 2, bgcolor: "white"}}>
                            <Typography fontWeight={600} sx={{mb: 1, color: grey[900]}}>
                                Your token session has expired
                            </Typography>
                            <Alert severity="error" sx={{mb: 2, fontSize: 14}}>
                                Your token is expired, please close this browser and get impersonate again.
                            </Alert>
                            <Typography fontSize={14}>
                                If you're still having trouble, please contact our support team at support@vnetwork.vn
                            </Typography>
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}